import * as Dialog from '@radix-ui/react-dialog'
import { type CodingGuidelinesResponse } from '../../utils/api-client/api-schemas.ts'
import { EditForm, useEditForm } from './edit-form.tsx'

export type EditDrawerProps = {
  organizationId?: string
  document: CodingGuidelinesResponse
  onSuccess: () => unknown
  onCancel: () => unknown
  onDelete: () => unknown
}

export const EditDrawer: React.FC<EditDrawerProps> = ({ organizationId, document, onSuccess, onCancel, onDelete }) => {
  const form = useEditForm({ displayName: document.display_name ?? '' })

  return (
    <Dialog.Root
      open
      modal={false}
      onOpenChange={open => {
        if (!open) {
          onCancel()
        }
      }}
    >
      <Dialog.Portal>
        <form.AppForm>
          <EditForm
            organizationId={organizationId}
            document={document}
            onSuccess={onSuccess}
            onCancel={onCancel}
            onDelete={onDelete}
          />
        </form.AppForm>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
